import {
  PERMISSIONS_ENABLE_LOADING,
  PERMISSIONS_DISABLE_LOADING,
  PERMISSIONS_UPDATE_DATA,
  PERMISSIONS_UPDATE_FILTER,
  PERMISSIONS_RESET_FILTER,
  PERMISSIONS_PAGINATION,
  PERMISSIONS_RESET_PAGINATION,
} from 'src/actions/constants';

const defaultState = {
  isLoading: false,
  appliedFilters: {

  },
  pagination: {
    currentPageNumber: 1,
    nextOrPrev: 'first',
  },
};

export default function (state: any = defaultState, action) {
  switch (action.type){
    case PERMISSIONS_UPDATE_DATA:
      return {
        ...state,
        permissionsData : action.data.permissions,
        isLoading:false,
        pagination: {
          ...state.pagination,
          isNextPresent: action.data ? action.data.isNextPresent : null,
          lastPermissionIdPrev: action.data ? action.data.lastPermissionIdPrev : null,
          lastPermissionIdNext: action.data ? action.data.lastPermissionIdNext : null,
        },
      };
    case PERMISSIONS_ENABLE_LOADING:
      return {
        ...state,
        isLoading : true,
      };
    case PERMISSIONS_DISABLE_LOADING:
      return {
        ...state,
        isLoading : false,
      };
    case PERMISSIONS_UPDATE_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...action.data,
        },
      };
    }
    case PERMISSIONS_RESET_FILTER: {
      return {
        ...state,
        appliedFilters: defaultState.appliedFilters,
      };
    }
    case PERMISSIONS_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    case PERMISSIONS_RESET_PAGINATION: {
      return {
        ...state,
        pagination: defaultState.pagination,
      };
    }
    default:
      return state;

  }
}
